import { useState } from 'react';
import './DebugOverlay.css';

interface DebugAction {
    label: string;
    onClick: () => void;
}

interface DebugOverlayProps {
    actions: DebugAction[];
}

const DebugOverlay = ({ actions }: DebugOverlayProps) => {
    const [isOpen, setIsOpen] = useState(false);

    if (process.env.NODE_ENV === 'production') return null;

    return (
        <div className="debug-overlay">
            <button
                className="debug-overlay-toggle"
                onClick={() => setIsOpen(!isOpen)}
            >
                {isOpen ? '✕' : '⚙'}
            </button>
            {isOpen && (
                <div className="debug-overlay-panel">
                    <div className="debug-overlay-header">Debug</div>
                    {actions.map((action, i) => (
                        <button
                            key={i}
                            className="debug-overlay-action"
                            onClick={() => {
                                action.onClick();
                                setIsOpen(false);
                            }}
                        >
                            {action.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DebugOverlay;
